import { MaybeUndef } from "shared";

/**
 * Joins the passed-in CSS classes with a space.
 */
export function joinClasses(...cssClasses: Array<MaybeUndef<string>>): string {
  return cssClasses.filter((className) => className != null).join(" ");
}
